import PropTypes from "prop-types";
import React from "react";
import DataTable from "./DataTable";
import SecondaryButton from "../Common/SecondaryButton";
import WhiteArrow from "../../assets/images/user-dashboard/white-right-arrow.svg"

/* -------------------------------------------------------------------------
 * RecentRedemptionsCard — dashboard preview of the Redemptions table
 * (adds a User Type column vs. the full Redemptions page).
 * ---------------------------------------------------------------------- */

const columns = [
  { key: "code", label: "Code", width: "1.2fr" },
  { key: "name", label: "Customer Name", width: "1.4fr" },
  { key: "email", label: "Email", width: "1.5fr" },
  { key: "value", label: "Value", width: "0.8fr", render: (r) => `$${r.value.toFixed(2)}` },
  { key: "status", label: "Status", width: "0.8fr" },
  { key: "date", label: "Date & Time", width: "1.2fr", align: "right" },
];

const RecentRedemptionsCard = ({ title, description, redemptions, onViewAll, compact = false }) => (
  <div className="rp-card">
    <div className="rp-card__header">
      <div>
        <h2 className="rp-card__title">{title}</h2>
        <p className="rp-card__subtitle">{description}</p>
      </div>
      <SecondaryButton
        type="button"
        variant="orange"
        icon={WhiteArrow}
        onClick={onViewAll}
      >
        View All
      </SecondaryButton>
    </div>

    <DataTable columns={columns} rows={redemptions} getRowKey={(r) => r.id} compact={compact} />
  </div>
);

RecentRedemptionsCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  redemptions: PropTypes.array.isRequired,
  onViewAll: PropTypes.func,
  compact: PropTypes.bool,
};

RecentRedemptionsCard.defaultProps = {
  title: "Recent Redemptions",
  description: "Latest vouchers used at your location.",
  onViewAll: () => {},
};

export default RecentRedemptionsCard;
